"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgCard = function SvgCard(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 110 100",
    fill: "none"
  }, props), {}, {
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M87.279 71.677H28.277a7.096 7.096 0 01-7.095-7.097V35.33a5.158 5.158 0 015.158-5.157h60.939a5.158 5.158 0 015.158 5.157v31.19a5.158 5.158 0 01-5.158 5.158zM12.995 67.972H6.2a1.562 1.562 0 110-3.125h6.794c.864 0 1.562.699 1.562 1.563s-.698 1.562-1.562 1.562z",
      fill: "#EDE6FF"
    }), (0, _jsxRuntime.jsx)("mask", {
      id: "card_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 60,
      y: 96,
      width: 10,
      height: 4,
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M60.072 96.523h9.919v3.124h-9.919v-3.124z",
        fill: "#fff"
      })
    }), (0, _jsxRuntime.jsx)("g", {
      mask: "url(#card_svg__a)",
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M68.428 99.648h-6.793a1.562 1.562 0 110-3.125h6.793a1.561 1.561 0 110 3.125z",
        fill: "#EDE6FF"
      })
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.355 73.25H3.563a1.562 1.562 0 110-3.125h6.792c.864 0 1.563.699 1.563 1.563s-.699 1.562-1.563 1.562z",
      fill: "#EDE6FF"
    }), (0, _jsxRuntime.jsx)("mask", {
      id: "card_svg__b",
      maskUnits: "userSpaceOnUse",
      x: 95,
      y: 4,
      width: 12,
      height: 13,
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M95.46 4.688h11.431v11.43H95.46V4.688z",
        fill: "#fff"
      })
    }), (0, _jsxRuntime.jsx)("g", {
      mask: "url(#card_svg__b)",
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M105.329 8.841h-2.591v-2.59a1.561 1.561 0 10-3.125 0v2.59h-2.59c-.864 0-1.563.699-1.563 1.563s.699 1.562 1.563 1.562h2.59v2.59a1.561 1.561 0 103.125 0v-2.59h2.591a1.56 1.56 0 001.562-1.562 1.56 1.56 0 00-1.562-1.563z",
        fill: "#EDE6FF"
      })
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M96.018 61.376a3.6 3.6 0 01-3.597 3.595h-60.94a3.6 3.6 0 01-3.594-3.595v-31.19a3.6 3.6 0 013.595-3.594H92.42a3.6 3.6 0 013.597 3.595v31.189zm-3.597-37.91h-60.94a6.73 6.73 0 00-6.72 6.72v31.19a6.73 6.73 0 006.72 6.72h60.94c3.706 0 6.722-3.015 6.722-6.72v-31.19c0-3.704-3.016-6.72-6.722-6.72z",
      fill: "#6542BE"
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M84.42 57.158c-.21 0-.41-.03-.61-.06a6.982 6.982 0 001.158-3.846c0-1.42-.431-2.739-1.158-3.845.2-.03.4-.061.61-.061a3.91 3.91 0 013.906 3.906 3.91 3.91 0 01-3.906 3.906zm-10.39-3.906a3.91 3.91 0 013.907-3.906c.207 0 .407.031.608.06a6.982 6.982 0 00-1.157 3.846c0 1.42.43 2.74 1.156 3.845-.2.03-.4.061-.607.061a3.91 3.91 0 01-3.906-3.906zm7.149 2.178a3.881 3.881 0 01-.666-2.178c0-.806.246-1.555.666-2.178a3.904 3.904 0 010 4.356zm3.24-9.21c-1.174 0-2.267.318-3.24.83-.975-.512-2.067-.83-3.242-.83a7.039 7.039 0 00-7.031 7.032 7.039 7.039 0 007.03 7.031c1.176 0 2.268-.317 3.243-.828.973.511 2.066.828 3.24.828 3.877 0 7.032-3.154 7.032-7.03 0-3.877-3.155-7.032-7.031-7.032zM45.764 40.104h-1.98v3.125h1.98v1.225a.783.783 0 01-.782.782H42.4v-7.212h2.582c.43 0 .782.352.782.783v1.297zm-9.853 4.35v-1.225h1.98v-3.125h-1.98v-1.297c0-.431.352-.783.783-.783h2.581v7.212h-2.58a.783.783 0 01-.784-.782zm9.07-9.555h-8.287a3.912 3.912 0 00-3.908 3.908v5.647a3.912 3.912 0 003.908 3.907h8.288a3.912 3.912 0 003.907-3.907v-5.647a3.912 3.912 0 00-3.907-3.908zM43.785 51.69h-7.873a1.561 1.561 0 100 3.125h7.873c.865 0 1.563-.699 1.563-1.563s-.698-1.562-1.563-1.562zM52.03 51.69h-1.55a1.561 1.561 0 100 3.125h1.55c.864 0 1.562-.699 1.562-1.563s-.698-1.562-1.562-1.562z",
      fill: "#6542BE"
    })]
  }));
};

var _default = SvgCard;
exports["default"] = _default;